<template>
  <div class="page-container content-430">
    <div class="search-block">
      <Form
        ref="searchForm"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">

          <FormItem label="">
            <Input
              v-model="searchInfo.orgName"
              placeholder="请输入机构名称"
            ></Input>
          </FormItem>
          <Button
            type="primary"
            style="margin-right: 16px"
            @click="handleSearch"
          >查询</Button>
          <Button @click="handleReset">重置</Button>
        </Row>
      </Form>
    </div>
    <div
      class="action-wrap flex justify-content_end"
      style="margin-top:8px;margin-bottom: 8px"
    >
      <Button
        class="btn-download"
        style="margin-left: 16px"
        type="primary"
        @click="handleAdd"
      >新建三方合作机构</Button>
    </div>
    <div class="table-main">
      <Table border :columns="tableColumn" :data="tableData" :loading="tableLoading">
        <template slot="action" slot-scope="{ row }">
          <span v-if="row.orgName==='宏兔兔平台'">-</span>
          <div v-else>
            <span class="click-btn-430" @click="handleEditOrg(row)">编辑</span>
            <span class="click-btn-430" style="color: red" @click="handleDelOrg(row)">删除</span>
          </div>

        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page class="page-right" :total="pageInfo.total" show-sizer show-elevator show-total :current="pageInfo.pageNo" :page-size-opts="pageSizeOpts" @on-change="handlePageChange" @on-page-size-change="handlePageSize"></Page>
    </div>
    <Modal v-model="showModal" :loading="modalLoading" width="50" :title="modalTitle" @on-ok="handleDealOrgInfo">
      <div class="modal-line">
        <span class="left-text">机构名称：</span>
        <Input
          v-model="orgName"
          class="line-input"
          placeholder="请输入机构名称"
        ></Input>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import common from '@/request/common';
export default {
  name: 'TreOrgList',
  components: {
  },
  data() {
    return {
      searchInfo: {
        orgName: ''
      },
      orgName: '', // 三方机构名称
      tableColumn: [
        {
          title: '三方课程机构名称',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 200
        },
        {
          title: '最近更新时间',
          key: 'operatorTime',
          minWidth: 200
        },
        {
          title: '最近更新人',
          key: 'operatorName',
          minWidth: 200
        },
        {
          title: '操作',
          slot: 'action',
          minWidth: 200
        }
      ],
      tableData: [],
      tableLoading: false,
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      pageSizeOpts: [10, 20, 50, 100],
      showModal: false,
      modalLoading: true,
      orgId: '',
      isEdit: false
    };
  },
  computed: {
    ...mapState(['userInfo']),
    modalTitle() {
      return this.isEdit ? '编辑三方课程机构' : '新建三方课程机构';
    }
  },
  created() {
    this.handleSearch();
  },
  methods: {
    handleSearch() {
      this.pageInfo.pageNo = 1;
      this.getOrgList();
    },
    // 获取机构列表
    async getOrgList() {
      const params = {
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      if (this.searchInfo.orgName) {
        params.orgName = this.searchInfo.orgName;
      }
      const res = await common.getKhOrgListApi(params);
      if (res.status === 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = +res.message.total;
      }
    },
    // 重置
    handleReset() {
      this.searchInfo.orgName = '';
      this.handleSearch();
    },
    handleDealOrgInfo() {
      if (this.isEdit) {
        this.editOrgTrue();
      } else {
        this.addOrgTrue();
      }
    },
    // 新建三方合作机构
    handleAdd() {
      this.orgName = '';
      this.modalLoading = true;
      this.isEdit = false;
      this.showModal = true;
    },
    handleEditOrg(orgInfo) {
      this.orgName = orgInfo.orgName;
      this.orgId = orgInfo.orgId;
      this.modalLoading = true;
      this.isEdit = true;
      this.showModal = true;
    },
    // 新建三方合作机构
    async addOrgTrue() {
      try {
        const res = await common.addKhOrgListApi({
          orgName: this.orgName
        });
        if (res.status === 200) {
          this.showModal = false;
          this.$Message.success('添加成功');
          this.handleSearch();
        } else {
          this.modalLoading = false;
          setTimeout(() => {
            this.modalLoading = true;
          }, 100);
        }
      } catch (err) {
        this.modalLoading = false;
        setTimeout(() => {
          this.modalLoading = true;
        }, 100);
      }
    },
    // 编辑三方合作机构
    async editOrgTrue() {
      try {
        const res = await common.updateOrgApi({
          orgName: this.orgName,
          orgId: this.orgId
        });
        if (res.status === 200) {
          this.showModal = false;
          this.$Message.success('编辑成功');
          this.getOrgList();
        } else {
          this.modalLoading = false;
          setTimeout(() => {
            this.modalLoading = true;
          }, 100);
        }
      } catch (err) {
        this.modalLoading = false;
        setTimeout(() => {
          this.modalLoading = true;
        }, 100);
      }
    },
    // 删除机构
    async handleDelOrg(orgInfo) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确定删除该机构吗？</p>',
        loading: true,
        onOk: async() => {
          this.delOrgTrue(orgInfo);
        }
      });
    },
    // 真的删除机构
    async delOrgTrue(orgInfo) {
      const res = await common.delOrgApi({
        orgId: orgInfo.orgId
      });
      if (res.status === 200) {
        this.$Modal.remove();
        this.$Message.success('删除成功');
        this.getOrgList();
      }
    },
    handlePageChange(pageNo) {
      this.pageInfo.pageNo = pageNo;
      this.getOrgList();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageSize === 1 && this.getOrgList();
    }
  }
};
</script>
<style lang='scss' scoped>
.modal-line{
  display: flex;
  align-items: center;
  .left-text{
    display: inline-block;
    width: 150px;
    position: relative;
    text-align: right;
    &::before{
      content: '*';
      color: red;
      left: -5px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .line-input{
    width: 400px;
  }
}
</style>
